import Modal from "frontend/modal/modal";
import style from "./replace-integration-item-modal.module.css";
import { CloseIcon } from "frontend/icons/close";
import { DynamicModal, ModalComponent, ModalProps } from "frontend/modal/dynamic-modal";
import tracking from "frontend/tracking";
import { useEffect } from "react";

interface ReplaceIntegrationItemModalResult {
  replace: boolean;
}

interface ReplaceIntegrationItemModalProps extends ModalProps<ReplaceIntegrationItemModalResult> {
  onComplete: (result: ReplaceIntegrationItemModalResult) => void;
  onClose: () => void;
}

const ReplaceIntegrationItemModal: ModalComponent<
  ReplaceIntegrationItemModalResult,
  ReplaceIntegrationItemModalProps,
  object
> = ({ onComplete, onClose }: ReplaceIntegrationItemModalProps) => {
  useEffect(() => {
    tracking.trackAnalyticsEvent("replace-integration-item-modal-shown");
  }, []);

  const handleComplete = (replace: boolean) => {
    tracking.trackAnalyticsEvent("replace-integration-item-modal-responded", {
      replace,
    });
    onComplete({ replace });
  };

  return (
    <Modal dimBackground={true} onClickBackground={onClose}>
      <div className={style.container}>
        <CloseIcon onClick={onClose} className={style.closeIcon} />
        <div className={style.header}>
          <div className={style.title}>Keep or replace item</div>
          <div className={style.description}>
            This shape already has a linked item from the same monday.com board. Do you want to replace it with the one
            you&apos;re dragging?
          </div>
        </div>

        <div className={style.content}>
          <div className={style.buttons}>
            <button className={style.outlineButton} onClick={() => handleComplete(false)}>
              Keep all items
            </button>
            <button className={style.filledButton} onClick={() => handleComplete(true)}>
              Replace items
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
ReplaceIntegrationItemModal.componentName = "ReplaceIntegrationItemModal";
DynamicModal.register(ReplaceIntegrationItemModal);

export default ReplaceIntegrationItemModal;
